import React, { useState, useContext, useEffect } from "react";

export const DataContext = React.createContext();
export const useData = () => useContext(DataContext);
export const DataProvider = ({ children, ...initOptions }) => {
    const [page, setPage] = useState(2);
    const [auto, setAuto] = useState(null);

    function doMoney(float) {
        let num = float.toLocaleString("de-DE", {
            style: "currency",
            currency: "EUR",
        });
        return num.slice(0, -2);
    }
    function doSpMoney(float) {
        let num = float.toLocaleString("de-DE", {
            style: "currency",
            currency: "EUR",
        });
        let numArray = num.split(",");
        if (numArray[1] == "00 €") {
            return numArray[0] + ",- € SB";
        }
    }

    const exports = {
        page,
        setPage,
        auto,
        setAuto,
        doMoney,
        doSpMoney,
    };
    return (
        <DataContext.Provider value={exports}>{children}</DataContext.Provider>
    );
};
